import React from 'react'

interface IReportTabletProps {
    title: string;
    description: string;
    color: 'primary' | 'green' | 'orange' | 'grey' | 'red';
}

const ReportTablet = (props: IReportTabletProps) => {
    const { title, description, color } = props;

    return (
        <div className='immersion_admin__report__tablet'>
            <h1 className={`immersion_admin__report__tablet__title immersion_admin__report__tablet__title__${color}`}>{title}</h1>
            <p className='immersion_admin__report__tablet__description'>{description}</p>
        </div>
    )
}

export default ReportTablet;